import React, { useState } from "react";
import "./Header.css";
import { Fade } from "react-reveal";
import { NavLink, Link } from "react-router-dom";
import { greeting, settings } from "../../portfolio.js";
import { CgSun } from "react-icons/cg/";
import { HiMoon } from "react-icons/hi";
import { style } from "glamor";

function Header(props) {
  const theme = props.theme;

  const styles = style({
    cursor: "pointer",
    height: "45px",
    width: "45px",
    marginRight: "5px",
    marginLeft: "15px",
    paddingTop: "5px",
    borderRadius: "50%",
    border: "none",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: props.theme.name === "light" ? "#7CD1F7" : "#292C3F",
    outline: "none",
    transition: "all 0.2s ease-in-out",
    ":hover": {
      boxShadow: `0 3px 8px ${
        props.theme.name === "light" ? "#F7D774" : "#646464"
      }`,
    },
  });

  const link = settings.isSplash ? "/splash" : "home";

  const [currTheme, setCurrTheme] = useState(props.theme);

  function changeTheme() {
    if (currTheme === "light") {
      props.setTheme("dark");
      localStorage.setItem("theme", "dark");
      setCurrTheme("dark");
    } else {
      props.setTheme("light");
      localStorage.setItem("theme", "light");
      setCurrTheme("light");
    }
  }

  const icon =
    props.theme.name === "dark" ? (
      <HiMoon
        strokeWidth={1}
        size={20}
        color={props.theme.name === "light" ? "#F9D784" : "#A7A7A7"}
      />
    ) : (
      <CgSun
        strokeWidth={1}
        size={20}
        color={props.theme.name === "light" ? "#F9D784" : "#A7A7A7"}
      />
    );

  return (
    <Fade top duration={1000} distance="20px">
      <div>
        <header className="header">
          <NavLink to={link} tag={Link} className="logo">
            <span style={{ color: theme.text }}></span>
            <div style={{ display: "flex", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="35"
                height="35"
                x="0"
                y="0"
                viewBox="0 0 32 32"
                class=""
              >
                <g>
                  <circle
                    cx="16"
                    cy="7.204"
                    r="1.578"
                    fill={`${theme.text}`}
                    opacity="1"
                    data-original={`${theme.text}`}
                    class=""
                  ></circle>
                  <path
                    d="M12.792 11.472c-.479.143-1.018.494-1.018 1.342v1.962h2.542zM11.999 21.51h-1.316v3.175h1.262c.424 0 .698-.098.822-.292.124-.195.186-.625.186-1.291 0-.688-.056-1.125-.167-1.312-.112-.187-.375-.28-.787-.28z"
                    fill={`${theme.text}`}
                    opacity="1"
                    data-original={`${theme.text}`}
                    class=""
                  ></path>
                  <path
                    d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm5.227 12.814v2.962h-5.105l2.491-5.401s2.614.034 2.614 2.439zM16 14.251l-1.708-3.781h3.416zm0-9.626a2.578 2.578 0 1 1 0 5.155 2.578 2.578 0 0 1 0-5.155zm-5.227 8.189c0-2.404 2.613-2.439 2.613-2.439l2.491 5.401h-5.105l.001-2.962zm2.764 12.119c-.21.331-.683.497-1.419.497h-2.32v-4.666h2.293c.652 0 1.108.143 1.369.428s.392.784.392 1.497c0 1.164-.105 1.912-.315 2.244zm4.081.497h-3.213v-4.666h3.191v.746H15.29v1.203h2.188v.652H15.29v1.319h2.328zm3.08 0h-1.36l-1.49-4.666h.919l.875 2.643c.082.253.204.677.366 1.271h.024l.088-.318c.109-.396.203-.713.281-.949l.864-2.646h.937z"
                    fill={`${theme.text}`}
                    opacity="1"
                    data-original={`${theme.text}`}
                    class=""
                  ></path>
                  <path
                    d="M20.227 14.775v-1.962c0-.848-.539-1.199-1.018-1.342l-1.524 3.304z"
                    fill={`${theme.text}`}
                    opacity="1"
                    data-original={`${theme.text}`}
                    class=""
                  ></path>
                </g>
              </svg>

              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                // xmlns:xlink="http://www.w3.org/1999/xlink"
                width="35"
                height="35"
                x="0"
                y="0"
                viewBox="0 0 512 512"
                // style="enable-background:new 0 0 512 512"
                // xml:space="preserve"
                class=""
              >
                <g>
                  <path
                    fill="#6cf5c2"
                    d="M136.289 272.402v62.582h231.832v-62.582c0-25.607-20.759-46.366-46.366-46.366h-139.1c-25.607 0-46.366 20.759-46.366 46.366z"
                    opacity="1"
                    data-original="#6cf5c2"
                    class=""
                  ></path>
                  <path
                    fill="#00f2a6"
                    d="M321.754 226.036h-33.301c25.607 0 46.366 20.759 46.366 46.366v62.583h33.301v-62.583c.001-25.607-20.758-46.366-46.366-46.366z"
                    opacity="1"
                    data-original="#00f2a6"
                    class=""
                  ></path>
                  <path
                    fill="#f6a96c"
                    d="M275.388 226.036v-41.73h-46.366v41.73c0 12.804 10.379 23.183 23.183 23.183s23.183-10.379 23.183-23.183z"
                    opacity="1"
                    data-original="#f6a96c"
                    class=""
                  ></path>
                  <path
                    fill="#fed2a4"
                    d="M252.205 207.489c-32.009 0-57.958-25.949-57.958-57.958v-4.637l-11.734-23.183 11.734-23.183v-4.637c0-32.009 25.949-57.958 57.958-57.958s57.958 25.949 57.958 57.958v55.64c0 32.01-25.949 57.958-57.958 57.958z"
                    opacity="1"
                    data-original="#fed2a4"
                    class=""
                  ></path>
                  <path
                    fill="#ffbd86"
                    d="M310.163 149.531v-4.637l9-23.183-9-23.183v-4.637c0-20.97-11.138-39.337-27.82-49.513V149.53c0 27.213-18.759 50.034-44.048 56.266a58.074 58.074 0 0 0 13.91 1.692c32.009.001 57.958-25.947 57.958-57.957z"
                    opacity="1"
                    data-original="#ffbd86"
                    class=""
                  ></path>
                  <path
                    fill="#7a6d79"
                    d="m326.391 121.712-16.228-23.183-24.129-20.107a5.998 5.998 0 0 0-7.499-.146l-7.445 5.727a70.052 70.052 0 0 1-42.71 14.527h-34.133l-16.228 23.183V74.186C178.019 33.214 211.233 0 252.205 0c40.972 0 74.186 33.214 74.186 74.186z"
                    opacity="1"
                    data-original="#7a6d79"
                    class=""
                  ></path>
                  <path
                    fill="#685e68"
                    d="M252.205 0a74.29 74.29 0 0 0-17.387 2.07c32.58 7.828 56.799 37.135 56.799 72.117v8.887l18.547 15.455 16.228 23.183V74.186C326.391 33.214 293.177 0 252.205 0z"
                    opacity="1"
                    data-original="#685e68"
                  ></path>
                  <path
                    fill="#f6a96c"
                    d="M321.754 144.895h-11.592V98.528h11.592c12.804 0 23.183 10.379 23.183 23.183.001 12.804-10.379 23.184-23.183 23.184zM182.655 144.895h11.592V98.528h-11.592c-12.804 0-23.183 10.379-23.183 23.183s10.38 23.184 23.183 23.184z"
                    opacity="1"
                    data-original="#f6a96c"
                    class=""
                  ></path>
                  <path
                    fill="#05e39c"
                    d="M319.436 342.485a7.5 7.5 0 0 1-7.5-7.5v-49.832a7.5 7.5 0 0 1 15 0v49.832a7.5 7.5 0 0 1-7.5 7.5zM184.974 342.485a7.5 7.5 0 0 1-7.5-7.5v-49.832a7.5 7.5 0 0 1 15 0v49.832a7.5 7.5 0 0 1-7.5 7.5z"
                    opacity="1"
                    data-original="#05e39c"
                    class=""
                  ></path>
                  <path
                    fill="#60b7ff"
                    d="M432.911 512H79.089c-11.495 0-20.813-9.318-20.813-20.813V345.496c0-11.495 9.318-20.813 20.813-20.813H432.91c11.495 0 20.813 9.318 20.813 20.813v145.691c.001 11.495-9.318 20.813-20.812 20.813z"
                    opacity="1"
                    data-original="#60b7ff"
                    class=""
                  ></path>
                  <path
                    fill="#26a6fe"
                    d="M432.911 324.683H399.61c11.495 0 20.813 9.318 20.813 20.813v145.691c0 11.495-9.318 20.813-20.813 20.813h33.301c11.495 0 20.813-9.318 20.813-20.813V345.496c0-11.495-9.319-20.813-20.813-20.813z"
                    opacity="1"
                    data-original="#26a6fe"
                    class=""
                  ></path>
                  <path
                    fill="#e8edf2"
                    d="M272.832 452.469h-27.579v-26.626h24.993a7.5 7.5 0 0 0 0-15h-24.993v-26.626h27.579a7.5 7.5 0 0 0 0-15h-35.079a7.5 7.5 0 0 0-7.5 7.5v83.252a7.5 7.5 0 0 0 7.5 7.5h35.079a7.5 7.5 0 0 0 0-15zM137.341 467.469a7.503 7.503 0 0 1-7.5-7.485l-.169-83.252a7.5 7.5 0 0 1 7.5-7.515h23.579c24.595 0 41.12 19.742 41.12 49.126 0 12.981-3.707 24.968-10.437 33.752-7.345 9.586-17.95 14.98-29.862 15.189-6.697.117-23.49.182-24.202.185h-.029zm7.347-83.253.139 68.216c5.537-.031 12.731-.081 16.483-.146 17.562-.307 25.561-17.81 25.561-33.943 0-16.498-6.862-34.126-26.12-34.126h-16.063zM344.692 467.469c-3.963 0-7.51-2.5-8.837-6.24l-28.482-82.053a7.5 7.5 0 0 1 14.171-4.919l23.032 66.355 21.961-66.107a7.5 7.5 0 1 1 14.235 4.729l-27.183 81.825c-1.302 3.828-4.845 6.383-8.834 6.41h-.063z"
                    opacity="1"
                    data-original="#e8edf2"
                    class=""
                  ></path>
                </g>
              </svg> */}
              <span className="logo-name" style={{ color: theme.text }}>
                {greeting.logo_name}
              </span>
            </div>
            <span style={{ color: theme.text }}></span>
          </NavLink>
          <input className="menu-btn" type="checkbox" id="menu-btn" />
          <label className="menu-icon" htmlFor="menu-btn">
            <span className="navicon"></span>
          </label>
          <ul className="menu">
            <li>
              <NavLink
                className="homei"
                to="/home"
                tag={Link}
                activeStyle={{ fontWeight: "bold" }}
                style={{ borderRadius: 5, color: theme.text }}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                className="ec"
                to="/education"
                tag={Link}
                activeStyle={{ fontWeight: "bold" }}
                style={{ borderRadius: 5, color: theme.text }}
              >
                Education
                {/* Education & Certifications */}
              </NavLink>
            </li>
            <li>
              <NavLink
                className="xp"
                to="/experience"
                tag={Link}
                activeStyle={{ fontWeight: "bold" }}
                style={{ borderRadius: 5, color: theme.text }}
              >
                Experience
              </NavLink>
            </li>
            <li>
              <NavLink
                className="projects"
                to="/projects"
                tag={Link}
                activeStyle={{ fontWeight: "bold" }}
                style={{ borderRadius: 5, color: theme.text }}
              >
                Projects
              </NavLink>
            </li>
            <li>
              <NavLink
                className="cr"
                to="/contact"
                tag={Link}
                activeStyle={{ fontWeight: "bold" }}
                style={{ borderRadius: 5, color: theme.text }}
              >
                Contact
                {/* Contact and Resume */}
              </NavLink>
            </li>
            <li>
              <a
                className="crs"
                target="_blank"
                rel="noopener noreferrer"
                href="https://drive.google.com/file/d/1LaqsOqlqkv3BLMtgyNzkGFr_hm7vziXw/view?usp=sharing"
                tag={Link}
                activeStyle={{ fontWeight: "bold" }}
                style={{ borderRadius: 5, color: theme.text }}
              >
                Resume
              </a>
            </li>
            <button {...styles} onClick={changeTheme}>
              {icon}
            </button>
          </ul>
        </header>
      </div>
    </Fade>
  );
}

export default Header;
